export const itemsMenu = [
  {
    sectionId: "home",
    title: "Inicio",
  },
  {
    sectionId: "services",
    title: "Servicios",
  },

  {
    sectionId: "about",
    title: "Nosotros",
  },
  {
    sectionId: "contact",
    title: "Contactos",
  },
];
